class CartDrawer {
  constructor() {
    this.drawer = document.querySelector('.cart-drawer');
    this.overlay = document.querySelector('.cart-drawer-overlay');
    this.closeBtn = this.drawer ? this.drawer.querySelector('.drawer-close') : null;
    this.cartCount = document.querySelector('.cart-count');
    this.cartBody = document.querySelector('.drawer-body');
    this.subtotal = document.querySelector('.cart-subtotal-price');

    this.init();
  }

  init() {
    // Open drawer on cart icon click
    document.querySelectorAll('.cart-btn, .cart-icon-wrapper, .cart-icon').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    // Close events
    this.closeBtn?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click', () => this.close());

    // Add to cart listeners (Event Delegation)
    document.addEventListener('click', (e) => {
      // Support both legacy .quick-add-btn and new .quick-add-trigger
      const btn = e.target.closest('.quick-add-btn, .quick-add-trigger');
      if (btn) {
        e.preventDefault();
        const variantId = btn.dataset.variantId;
        // If no variant ID (e.g. placeholders), do nothing or alert logic
        if (!variantId) return;

        this.addToCart(variantId, btn);
      }
    });
  }

  open() {
    this.drawer.classList.add('open');
    this.overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    this.fetchCart();
  }

  close() {
    this.drawer.classList.remove('open');
    this.overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  async addToCart(variantId, btnElement) {
    const originalContent = btnElement ? btnElement.innerHTML : '';
    const isIconBtn = btnElement && btnElement.classList.contains('quick-add-trigger');

    if (btnElement) {
      // Spinner SVG
      // Use smaller spinner for icon buttons
      const r = isIconBtn ? 16 : 20;
      const sw = isIconBtn ? 4 : 5;
      btnElement.innerHTML = `<svg class="spinner" viewBox="0 0 50 50"><circle class="path" cx="25" cy="25" r="${r}" fill="none" stroke-width="${sw}"></circle></svg>`;
      btnElement.disabled = true;
    }

    // Fly Animation (Slower)
    if (btnElement) {
      this.animateFlyToCart(btnElement);
    }

    try {
      const response = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });

      if (response.ok) {
        await this.fetchCart();
        // Show Global Luxury Toast
        if (window.showToast) window.showToast('Product added to selection');
        // Open immediately after fetch
        this.open();
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
    } finally {
      if (btnElement) {
        // Revert after animation/delay
        setTimeout(() => {
          if (isIconBtn) {
            btnElement.innerHTML = originalContent;
          } else {
            btnElement.textContent = 'ADD TO CART'; // Legacy Fallback
          }
          btnElement.disabled = false;
        }, 1500);
      }
    }
  }

  animateFlyToCart(btn) {
    const productCard = btn.closest('.product-card, .product-card-item'); // Support both classes
    if (!productCard) return;

    const img = productCard.querySelector('img');
    if (!img) return;

    const cartIcon = document.querySelector('.cart-btn') || document.querySelector('.cart-icon-wrapper');
    if (!cartIcon) return;

    const imgClone = img.cloneNode(true);
    const imgRect = img.getBoundingClientRect();
    const cartRect = cartIcon.getBoundingClientRect();

    imgClone.style.position = 'fixed';
    imgClone.style.top = imgRect.top + 'px';
    imgClone.style.left = imgRect.left + 'px';
    imgClone.style.width = imgRect.width + 'px';
    imgClone.style.height = imgRect.height + 'px';
    imgClone.style.zIndex = '9999';
    imgClone.style.transition = 'all 1.5s cubic-bezier(0.2, 1, 0.3, 1)'; // Slower animation
    imgClone.style.borderRadius = '50%';
    imgClone.style.opacity = '0.8';
    imgClone.style.pointerEvents = 'none';

    document.body.appendChild(imgClone);

    // Trigger animation
    requestAnimationFrame(() => {
      imgClone.style.top = (cartRect.top + 10) + 'px';
      imgClone.style.left = (cartRect.left + 10) + 'px';
      imgClone.style.width = '20px';
      imgClone.style.height = '20px';
      imgClone.style.opacity = '0';
    });

    setTimeout(() => {
      imgClone.remove();
    }, 1500);
  }

  async fetchCart() {
    const response = await fetch(window.routes.cart_url + '.js');
    const cart = await response.json();
    this.renderCart(cart);
  }

  renderCart(cart) {
    // Update count
    const countElements = document.querySelectorAll('.cart-count');
    countElements.forEach(el => el.textContent = cart.item_count);

    // Update subtotal
    if (this.subtotal) this.subtotal.textContent = this.formatMoney(cart.total_price);

    // Free Shipping Removed as per request
    let shippingHTML = '';


    // Prepend Shipping Bar to Drawer Body
    // We'll insert it before the items list if items exist

    // Update items
    if (cart.item_count === 0) {
      this.cartBody.innerHTML = `
        ${shippingHTML}
        <div class="empty-cart-container">
          <div class="empty-icon">🛒</div>
          <p>Your cart is empty.</p>
          <button class="btn" onclick="cartDrawer.close()">Start Shopping</button>
        </div>`;
      // Hide footer if empty
      const footer = document.querySelector('.drawer-footer');
      if (footer) footer.style.display = 'none';
      return;
    }

    // Show footer
    const footer = document.querySelector('.drawer-footer');
    if (footer) {
      footer.style.display = 'block';
      if (!footer.querySelector('.checkout-btn')) {
        const isPreorder = window.themeConfig && window.themeConfig.enablePreorderMode;
        const checkoutText = isPreorder ? (window.themeConfig.preorderButtonText || 'CONFIRM PRE-ORDER') : 'CHECKOUT';
        const checkoutLink = isPreorder ? '/cart' : '/checkout';

        footer.innerHTML = `
          <div class="cart-subtotal-row">
            <span>Subtotal</span>
            <span class="cart-subtotal-price">${this.formatMoney(cart.total_price)}</span>
          </div>
          <div class="cart-buttons" style="display: flex; flex-direction: column; gap: 10px;">
            <a href="/cart" class="btn btn-outline" style="width: 100%; display: block; text-align: center; text-decoration: none;">VIEW CART</a>
            <a href="${checkoutLink}" class="btn checkout-btn" style="width: 100%; display: block; text-align: center; text-decoration: none;">${checkoutText}</a>
          </div>
        `;
        this.subtotal = footer.querySelector('.cart-subtotal-price');
      }
    }

    // Render Items
    this.cartBody.innerHTML = `
      ${shippingHTML}
      <div class="cart-items-list">
        ${cart.items.map(item => `
          <div class="cart-item">
            <div class="cart-item-image-wrapper">
               <img src="${item.image}" alt="${item.title}">
            </div>
            <div class="cart-item-details">
              <div class="cart-item-header">
                <a href="${item.url}" class="cart-item-title">${item.product_title}</a>
                <button class="remove-btn" onclick="cartDrawer.updateQuantity(${item.variant_id}, 0)" aria-label="Remove">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  </svg>
                </button>
              </div>
              
              ${(item.variant_title && item.variant_title !== 'Default Title' && item.variant_title !== 'null') ? `<p class="cart-item-variant" style="color: #666; font-size: 0.85rem;">${item.variant_title}</p>` : ''}
              
              ${(item.properties && Object.keys(item.properties).length > 0) ? `
                <div class="cart-item-properties" style="margin-top: 5px; font-size: 0.75rem; color: #666;">
                  ${Object.entries(item.properties).map(([key, value]) => {
      if (!value || value === 'null') return '';
      return `
                      <div class="property-item">
                        <span style="font-weight: 600;">${key}:</span> ${value}
                      </div>
                    `;
    }).join('')}
                </div>
              ` : ''}
              
              <div class="cart-item-footer">
                <div class="cart-quantity-selector pill">
                  <button class="qty-btn minus" onclick="cartDrawer.updateQuantity(${item.variant_id}, ${item.quantity - 1})">-</button>
                  <span class="qty-val">${item.quantity}</span>
                  <button class="qty-btn plus" onclick="cartDrawer.updateQuantity(${item.variant_id}, ${item.quantity + 1})">+</button>
                </div>
                <div class="cart-item-price">${this.formatMoney(item.price)}</div>
              </div>
            </div>
          </div>
        `).join('')}
      </div>
    `;
  }

  async updateQuantity(variantId, quantity) {
    await fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId.toString(), quantity: quantity })
    });
    this.fetchCart();
  }

  formatMoney(cents) {
    return '₹' + (cents / 100).toFixed(2);
  }
}

const cartDrawer = new CartDrawer();
window.cartDrawer = cartDrawer;

// Global Open Cart Function for inline onclicks
window.openCart = () => cartDrawer.open();
window.addToCart = (id) => cartDrawer.addToCart(id); // Fallback if needed
